"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultColorShadeIndex = exports.colorShades = exports.PICKER_TOOL_WIDTH = exports.ITEM_WIDTH = void 0;
exports.ITEM_WIDTH = 36;
exports.PICKER_TOOL_WIDTH = exports.ITEM_WIDTH * 4;
exports.colorShades = [50, 100, 200, 300, 400, 500, 600, 700, 800, 900, 'A100', 'A200', 'A400', 'A700'];
exports.defaultColorShadeIndex = 5;
